export default __webpack_public_path__ + "static/media/waiting-times-mobile.5bf994da.png";